import { render } from "./ArticleModalInfoBox.vue?vue&type=template&id=7119c8d6&scoped=true"
import script from "./ArticleModalInfoBox.vue?vue&type=script&lang=js"
export * from "./ArticleModalInfoBox.vue?vue&type=script&lang=js"

import "./ArticleModalInfoBox.vue?vue&type=style&index=0&id=7119c8d6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7119c8d6"

export default script